import { render, staticRenderFns } from "./PagePushNotificationsHowTo.vue?vue&type=template&id=25a5aafc&scoped=true&"
import script from "./PagePushNotificationsHowTo.vue?vue&type=script&lang=ts&"
export * from "./PagePushNotificationsHowTo.vue?vue&type=script&lang=ts&"
import style0 from "./PagePushNotificationsHowTo.vue?vue&type=style&index=0&id=25a5aafc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a5aafc",
  null
  
)

export default component.exports